<script>
export default {
    functional: true,

    render: function(createElement, context){
        return createElement("div", {
            "class": {
                alert: true,
                "alert-success": true
            },
            style: {
                margin: 0
            }
        }, context.props.messages.map(m => {
            return createElement("strong", m);
        }));
    }
};
</script>
